module.exports = __webpack_public_path__ + "static/img/icon-instmng-offline-pay.2d0c220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instmng/instlist/icon-instmng-offline-pay.png
// module id = 870g
// module chunks = 1